import React from "react";
import { Helmet } from "react-helmet";
import HeaderDark from "../../../../components/Header/HeaderDark";
import FooterThreeDark from "../../../../components/Footer/FooterThreeDark";
import CopyRight from "../../../../components/Footer/Copyright/CopyRight";
import TicketsList from "./ticketsList";

const NewTicket = () => {
  return (
    <div>
      <Helmet>
        <title>Githubit - Tickets</title>
      </Helmet>
      <HeaderDark />
      <div className="ptf-main">
        <div className="ptf-page ptf-page--contact">
          <section>
            <div
              className="ptf-spacer"
              style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
            />
            <div className="container-xxl">
              <div className="row">
                <div className="col-xl-10">
                  <div
                    className="ptf-animated-block"
                    data-aos="fade"
                    data-aos-delay="0"
                  >
                    <h1 className="large-heading text-white">
                      My Support Tickets:
                    </h1>
                    <div
                      className="ptf-spacer"
                      style={{ "--ptf-xxl": "3rem", "--ptf-md": "2.5rem" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="ptf-spacer" />
          </section>

          <section>
            <div className="container-xxl">
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="ptf-animated-block"
                    data-aos="fade"
                    data-aos-delay="300"
                  >
                    <div className="ptf-spacer" />
                    <TicketsList />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="ptf-spacer"
              style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
            />
          </section>
        </div>
      </div>

      <footer className="ptf-footer ptf-footer--style-5">
        <div className="container-xxl">
          <div
            className="ptf-divider"
            style={{
              "--ptf-height": "1px",
              "--ptf-color": "var(--border-color)",
            }}
          />
          <div className="ptf-footer__top">
            <FooterThreeDark />
          </div>

          <div className="ptf-footer__bottom">
            <CopyRight />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NewTicket;
